import { useEffect } from 'react';
import { mcpKeyService } from '../services/mcpKeyService';

/**
 * Hook to automatically refresh MCP API key JWT token
 * Runs every 12 hours to keep the token fresh
 */
export const useMCPTokenRefresh = () => {
  useEffect(() => {
    // Refresh immediately on mount if user has been active for a while
    const refreshToken = async () => {
      try {
        await mcpKeyService.refreshToken();
        // console.log('MCP token refreshed successfully');
      } catch (error) {
        // console.error('Failed to refresh MCP token:', error);
      }
    };

    // Refresh on mount
    refreshToken();

    // Set up interval to refresh every 12 hours
    const intervalId = setInterval(() => {
      refreshToken();
    }, 12 * 60 * 60 * 1000); // 12 hours in milliseconds

    return () => clearInterval(intervalId);
  }, []);
};
